import { queryOptions } from '@tanstack/react-query';
import { userServiceRepository } from 'services/api/userService/ApiUserServiceRepository';
import type { User } from '@proposify/users-bff-api-client';
import { QueryKeys } from 'utils/queryKeys';

export const userBffQueries = {
  currentUser: queryOptions<User | null>({
    queryKey: QueryKeys.userBffCurrentUser,
    queryFn: async () => {
      try {
        return await userServiceRepository.getCurrentUser();
      } catch {
        // error already tracked inside repository via trackError()
        return null;
      }
    },
    staleTime: Infinity,
  }),
};
